export default {
  // ===== COMMON =====
  'common.shopNow': 'Shop Now',
  'common.whereToBuy': 'Where to Buy',
  'common.learnMore': 'Learn More',
  'common.readMore': 'Read More',
  'common.subscribe': 'Subscribe',
  'common.submit': 'Submit',
  'common.download': 'Download',
  'common.verify': 'Verify',
  'common.discover': 'Discover',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.close': 'Close',
  'common.search': 'Search',
  'common.filter': 'Filter',
  'common.loading': 'Loading...',
  'common.freeShipping': 'Free Shipping',
  'common.over': 'Over',
  'common.save': 'Save',
  'common.from': 'from',
  'common.step': 'Step',
  'common.set': 'Set',
  'common.officialStore': 'Official Store',
  'common.partnerPharmacies': 'Partner Pharmacies',
  'common.onlineRetailers': 'Online Retailers',
  'common.getDirections': 'Get Directions',
  'common.call': 'Call',
  'common.hours': 'Hours',
  'common.address': 'Address',
  'common.contact': 'Contact',
  'common.apply': 'Apply',
  'common.contact': 'Contact',
  'common.seeAll': 'See All',
  'common.viewDetails': 'View Details',
  'common.addToCart': 'Add to Cart',
  'common.checkout': 'Checkout',
  'common.placeOrder': 'Place Order',
  'common.continueShopping': 'Continue Shopping',

  // ===== NAV =====
  'nav.brandStory': 'Brand Story',
  'nav.threeStep': '3-Step Treatment',
  'nav.products': 'Products',
  'nav.content': 'Content',
  'nav.whereToBuy': 'Where to Buy',
  'nav.shop': 'Shop',
  'nav.account': 'Account',
  'nav.cart': 'Cart',

  // ===== FOOTER =====
  'footer.brandDesc': "Bangladesh's first dermocosmetic K-Beauty brand. Pharmacist-recommended clinical ingredients, Korean innovation, authentic results.",
  'footer.hotlineLabel': 'Hotline',
  'footer.hotline': '+880 1XXX-XXXXXX',
  'footer.brand': 'Brand',
  'footer.products': 'Products',
  'footer.support': 'Support',
  'footer.brandStory': 'Brand Story',
  'footer.threeStepTreatment': '3-Step Treatment',
  'footer.ourPhilosophy': 'Our Philosophy',
  'footer.ingredientResearch': 'Ingredient Research',
  'footer.step01': 'Step 01 — Skin Priming Booster Essence',
  'footer.step02': 'Step 02 — Daily Rescue Serum',
  'footer.step03': 'Step 03 — Barrier Seal Cream',
  'footer.threeStepSet': '3-Step Set',
  'footer.shopAll': 'Shop All',
  'footer.aboutUs': 'About Us',
  'footer.contactUs': 'Contact Us',
  'footer.faq': 'FAQ',
  'footer.shippingReturns': 'Shipping & Returns',
  'footer.privacyPolicy': 'Privacy Policy',
  'footer.termsOfService': 'Terms of Service',
  'footer.copyright': '\u00a9 2026 The.K Seoul Co., Ltd. All rights reserved.',
  'footer.dgda': 'DGDA Registration: In Progress',
  'footer.parentCompany': 'Parent Company',
  'footer.marketingAuth': 'Marketing Authorization Holder (\u5316\u599d\u54C1\uCC45\uC784\uD310\uB9E4\uC5C5\uC790): The.K Seoul Co., Ltd. (Korea)',
  'footer.manufacturer': 'Manufacturer (\u5316\u599d\u54C1\uC81C\uC870\uC5C5\uC790): Jungin Cosmetics Co., Ltd. (Korea)',
  'footer.bdOperations': 'Bangladesh Operations: Sol Grace Construction BD. Ltd. \u2014 Dhaka, Bangladesh',
  'footer.registeredAddress': 'Registered Address: Apt-A1, House 94, Park Road, Block-K, Baridhara, Dhaka-1212, Bangladesh',
  'footer.tradeLicense': 'Trade License No.: TRAD/DNCC/027028/2025',

  // ===== HOME HERO =====
  'home.hero.dailyTreatment': '3-Step Daily Treatment',
  'home.hero.prescription': 'Skincare Prescription',
  'home.hero.kBeauty': 'for your skin, by K-Beauty',
  'home.hero.subtitle': 'Pharmacist-recommended clinical ingredients. Authenticity guaranteed. 3-Step Daily Treatment.',
  'home.hero.ctaProducts': 'Our Products',
  'home.hero.ctaWhereToBuy': 'Where to Buy',
  'home.hero.statClean': '100% Clean',
  'home.hero.statCleanSub': 'Clinical Grade',
  'home.hero.statDerma': 'K+ Derma',
  'home.hero.statDermaSub': 'Korean Innovation',
  'home.hero.statPrescribed': 'Rx Prescribed',
  'home.hero.statPrescribedSub': 'Pharmacist Verified',
  'home.hero.scroll': 'Scroll',
  'home.hero.trustBadge1': 'GMP Certified Manufacturing',
  'home.hero.trustBadge2': 'Pharmacist Verified Formula',
  'home.hero.trustBadge3': 'DGDA Registration In Review',
  'home.hero.trustBadge4': 'Made in Korea',

  // ===== HOME BRAND STORY =====
  'home.brandStory.label': 'Brand Story',
  'home.brandStory.heading': 'Where Your Skin',
  'home.brandStory.subheading': 'Meets K-Beauty',
  'home.brandStory.body': "Rx.K Seoul was born from a simple question: why should effective, dermatologist-grade skincare be inaccessible? We fused Korean R&D excellence with clinical-grade formulations — and brought it to Bangladesh as the nation's first pharmacy-cosmetic K-Beauty brand. Every ingredient is chosen for proven efficacy. Every step is prescribed for visible results.",
  'home.brandStory.pillar1.title': 'Rx Prescription',
  'home.brandStory.pillar1.sub': 'Clinical-Grade',
  'home.brandStory.pillar2.title': 'K-Beauty',
  'home.brandStory.pillar2.sub': 'Korean Innovation',
  'home.brandStory.pillar3.title': 'Barrier Repair',
  'home.brandStory.pillar3.sub': 'Skin Protection',
  'home.brandStory.cta': 'Read Our Story →',
  'home.brandStory.est': 'Est.',
  'home.brandStory.year': '2026',
  'home.brandStory.seoul': 'Seoul',

  // ===== HOME ROUTINE =====
  'home.routine.label': 'Daily Ritual',
  'home.routine.heading': '3-Step Daily Treatment',
  'home.routine.tagline': 'Open · Treat · Lock',
  'home.routine.cta': 'Full Routine Guide →',

  // ===== HOME LAUNCH GALLERY =====
  'home.launchGallery.eyebrow': 'LAUNCH SHOWCASE — K-GOODS FESTA 2026',
  'home.launchGallery.heading': 'Where K-Beauty Met Bangladesh, In Person.',
  'home.launchGallery.subline': 'Co-hosted by KOTRA & the Embassy of the Republic of Korea in Bangladesh · Jamuna Future Park · 19-20 June 2026',
  'home.launchGallery.caption.brandPanel': 'Prescribed by Science, Designed for You',
  'home.launchGallery.caption.booth': 'The.K Seoul pavilion, Jamuna Future Park',
  'home.launchGallery.caption.consult': 'Science-first skincare advice',
  'home.launchGallery.caption.crowd': 'A full house at the Rx.K Testing Zone',
  'home.launchGallery.caption.model': 'Live consultation at the VIP Corner',
  'home.launchGallery.caption.model2': 'Discovering the 3-Step Daily Treatment',
  'home.launchGallery.caption.team': 'Bangladesh x Korea — our team at the booth',
  'home.launchGallery.caption.team2': 'Bangladesh x Korea — our team at the booth',
  'home.launchGallery.badge': 'As seen on Jamuna TV',
  'home.launchGallery.cta': 'Explore the 3-Step Set →',

  // ===== HOME CTA SPLIT =====
  'home.ctaSplit.left.brand': 'Rx+. K SEOUL',
  'home.ctaSplit.left.heading': 'Experience K-Beauty Prescribed by Korean Pharmacists',
  'home.ctaSplit.right.heading': 'Start Your Routine Today',
  'home.ctaSplit.right.body': "Be among the first in Bangladesh to switch to pharmacist-recommended skincare. Clinical ingredients, Korean innovation, authentic results — delivered to your door.",
  'home.ctaSplit.right.step1': '01 OPEN',
  'home.ctaSplit.right.step2': '02 TREAT',
  'home.ctaSplit.right.step3': '03 LOCK',
  'home.ctaSplit.right.ctaShop': 'Shop Now →',
  'home.ctaSplit.right.ctaWhere': 'Where to Buy →',
  'home.ctaSplit.stat1.label': 'Free Shipping',
  'home.ctaSplit.stat1.value': 'Over ৳3,000',
  'home.ctaSplit.stat2.label': 'Mileage Rewards',
  'home.ctaSplit.stat2.value': '10% Back',
  'home.ctaSplit.stat3.label': 'Every Product',
  'home.ctaSplit.stat3.value': 'QR Verified',

  // ===== HOME ARTICLES =====
  'home.articles.label': 'Knowledge',
  'home.articles.heading': 'Skincare Intelligence',
  'home.articles.cta': 'All Articles →',

  // ===== HOME AUTHENTICITY =====
  'home.authenticity.label': '100% Genuine Guarantee',
  'home.authenticity.subLabel': 'DGDA-registered verification system',
  'home.authenticity.heading': 'Scan. Verify. Trust.',
  'home.authenticity.body': 'Every Rx.K Seoul box comes with a unique QR code. Scan to verify the authorized retail store, and confirm your product is genuine — directly from The.K Seoul Co., Ltd. in Korea.',
  'home.authenticity.cta': 'Verify Your Product',
  'home.authenticity.badge': 'Scan QR on product',

  // ===== HOME NEWSLETTER =====
  'home.newsletter.heading': 'Stay Updated',
  'home.newsletter.body': 'Get skincare tips, ingredient science, and exclusive offers for the Bangladesh market.',
  'home.newsletter.placeholder': 'Enter your email address',
  'home.newsletter.submit': 'Subscribe',
  'home.newsletter.success': 'Thank you for subscribing! Check your inbox for a welcome message.',
  'home.newsletter.error': 'Please enter a valid email address.',
  'home.newsletter.privacy': 'By subscribing, you agree to receive marketing emails. Unsubscribe anytime.',

  // ===== HOME REVIEWS =====
  'home.reviews.label': 'Real Reviews',
  'home.reviews.heading': 'Reviews That Speak for Themselves',
  'home.reviews.subtext': 'Real reviews from Rx.K Seoul customers around the world.',

  // ===== BRAND STORY =====
  'brandV2.hero.journey': 'Our story',
  'brandV2.founder.label': 'A word from our founder',
  'brandV2.founder.quote': 'We started The.K Seoul to bring pharmacy-grade Korean skincare to the people who need it most, and to make sure every box they open is the real thing.',
  'brandV2.glance.n1': '3',
  'brandV2.glance.l1': 'Steps in one routine',
  'brandV2.glance.n2': '37+',
  'brandV2.glance.l2': 'Partner pharmacies in Dhaka',
  'brandV2.glance.n3': '2026',
  'brandV2.glance.l3': 'Launched in Bangladesh',
  'brandV2.glance.n4': '100%',
  'brandV2.glance.l4': 'Boxes you can verify',
  'brandV2.film.label': 'Our film',
  'brandV2.film.heading': 'Rx.K Seoul,',
  'brandV2.film.headingEm': 'in motion.',
  'brandV2.film.watch': 'Watch our film',
  'brandV2.founder.message': "Korean skincare is trusted around the world, but in Bangladesh it is too often sold without proof that it is real, and without advice on what actually suits our skin.\nSo we built Rx.K Seoul the way a pharmacy would: a short routine with ingredients chosen for a purpose, made in Korea, checked batch by batch, and verifiable on every box.",
  'brandV2.company.label': "Company profile",
  'brandV2.company.heading': "The.K Seoul Co., Ltd.",
  'brandV2.company.f1l': "Parent company",
  'brandV2.company.f1v': "The.K Seoul Co., Ltd., Korea",
  'brandV2.company.f2l': "Headquarters",
  'brandV2.company.f2v': "Anyang-si, Gyeonggi-do, Korea",
  'brandV2.company.f3l': "Manufacturer",
  'brandV2.company.f3v': "Jungin Cosmetics Co., Ltd., Korea",
  'brandV2.company.f4l': "Bangladesh operations",
  'brandV2.company.f4v': "Sol Grace Construction BD. Ltd., Dhaka",
  'brandV2.company.f5l': "Launched in Bangladesh",
  'brandV2.company.f5v': "June 2026 · K-Goods Festa, Dhaka",
  'brandV2.company.f6l': "Trade licence",
  'brandV2.company.f6v': "TRAD/DNCC/027028/2025",
  'brandV2.company.family': "Rx.K Seoul · Pick.K Seoul · Medi.K Seoul",
  'brandV2.name.label': "The brand",
  'brandV2.name.heading': "What Rx.K Seoul means",
  'brandV2.name.lead': "Three parts, one idea: skincare prescribed with care, made in Korea, for your skin.",
  'brandV2.name.rx.mark': "Rx",
  'brandV2.name.rx.title': "Prescription",
  'brandV2.name.rx.text': "The pharmacy sign for a formula chosen for a reason. Every ingredient in our routine has a job, at a level that works.",
  'brandV2.name.k.mark': "K",
  'brandV2.name.k.title': "Korea",
  'brandV2.name.k.text': "Developed with Korean R&D and made in Korean GMP facilities, to the standards Korean pharmacies expect.",
  'brandV2.name.seoul.mark': "Seoul",
  'brandV2.name.seoul.title': "Our home",
  'brandV2.name.seoul.text': "Where our parent company and research team are based, and where every batch begins its trip to Dhaka.",
  'brandV2.founder.word': "FOUNDER",
  'brandV2.brands.rxk': "Pharmacist-curated dermocosmetic skincare, made in Korea for skin in Bangladesh.",
  'brandV2.brands.pickk': "An invite-only B2B platform connecting creators in Bangladesh with products from Korea.",
  'brandV2.brands.medik': "Medical tourism to Seoul: partner clinics for skin, surgery, dentistry and health screening.",
  'brandV2.brands.here': "You are here",
  'brandV2.company.familyLabel': "The.K Seoul family",
  'brandV2.company.tagLabel': "The.K Seoul",
  'brandV2.company.tag': "Global bridge of trusted K-commerce",
  'brandV2.company.routeFrom': "R&D and manufacturing",
  'brandV2.company.routeTo': "Bangladesh operations",
  'brandV2.company.familyHeading': "Three brands, one standard of trust",
  'brandV2.name.result': "Pharmacy care, Korean quality, Seoul at heart",
  'brandV2.manifesto.quote': 'Pharmacy, meet cosmetics. Prescribed beauty.',
  'brandV2.manifesto.text': 'Rx.K Seoul is a dermocosmetic brand from Seoul: pharmacist-chosen ingredients, Korean manufacturing and one short routine, made for skin in Bangladesh.',
  'brandV2.journey.label': 'From Seoul to you',
  'brandV2.journey.heading': 'Every box,',
  'brandV2.journey.headingEm': 'traced to the factory.',
  'brandV2.journey.step1.title': 'Formulated in Seoul',
  'brandV2.journey.step1.text': 'Pharmacist-curated formulas from Korean R&D.',
  'brandV2.journey.step2.title': 'Made in GMP facilities',
  'brandV2.journey.step2.text': 'Korean factories with strict quality control.',
  'brandV2.journey.step3.title': 'Batch-tracked',
  'brandV2.journey.step3.text': 'Every batch followed from Seoul to Dhaka.',
  'brandV2.journey.step4.title': 'QR on every box',
  'brandV2.journey.step4.text': 'Scan the silver hologram to verify it in seconds.',
  'brandV2.journey.step5.title': 'At your door',
  'brandV2.journey.step5.text': 'Only through official channels. Pay the rider on delivery.',
  'brandV2.journey.verify': 'Verify your product',
  'brandV2.cta.shop': 'Shop the 3-Step Set',
  'brandStory.hero.label': 'Our Story',
  'brandStory.hero.heading': "Where K-beauty Prescription",
  'brandStory.hero.subheading': 'Meets Your Skin',
  'brandStory.hero.subtitle': "Bangladesh's first dermocosmetic K-Beauty brand",
  'brandStory.problem.label': 'The Problem',
  'brandStory.problem.heading': 'The Trust Gap in K-Beauty',
  'brandStory.problem.p1': "Bangladesh's K-Beauty market is exploding — but so is the problem. Counterfeit products flood online marketplaces, sold at suspiciously low prices with no way to verify authenticity. Consumers in Dhaka, Chittagong, and Sylhet are spending their hard-earned money on products that may be fake, expired, or even harmful.",
  'brandStory.problem.p2': "Even when products are genuine, most consumers don't know which ingredients actually work for South Asian skin concerns — hyperpigmentation from tropical sun, uneven skin tone, barrier damage from humidity and pollution, and acne triggered by Dhaka's climate. They buy what influencers recommend, not what pharmacists would prescribe.",
  'brandStory.problem.p3': 'The result? Wasted money, damaged skin barriers, and a growing distrust in the very category that should be helping people feel confident in their skin.',
  'brandStory.problem.stat1': '70%+',
  'brandStory.problem.stat1Label': 'Counterfeit risk in unverified channels',
  'brandStory.problem.stat2': '0',
  'brandStory.problem.stat2Label': 'Local dermatocosmetic K-Beauty brands',
  'brandStory.problem.stat3': '৳12,000+',
  'brandStory.problem.stat3Label': 'Average annual spend on ineffective products',
  'brandStory.solution.label': 'Our Solution',
  'brandStory.solution.heading': 'Rx.K Seoul — Prescription K-Beauty',
  'brandStory.solution.body': 'Dermocosmetics — where pharmacy meets cosmetics. We combine pharmacist-curated ingredient selection with Korean R&D excellence, delivering clinical-grade formulations at accessible prices. Every product is designed to be prescribed: chosen for a purpose, tested for safety, and verified for authenticity.',
  'brandStory.solution.feature1.title': 'Clinical Trust',
  'brandStory.solution.feature1.point1': 'Pharmacist-curated formulations',
  'brandStory.solution.feature1.point2': 'Dermatologically tested on South Asian skin',
  'brandStory.solution.feature1.point3': 'Korean pharmaceutical manufacturing standards',
  'brandStory.solution.feature1.point4': 'Active ingredients at clinically effective concentrations',
  'brandStory.solution.feature2.title': 'Authenticity Guaranteed',
  'brandStory.solution.feature2.point1': 'Unique QR code on every product box',
  'brandStory.solution.feature2.point2': 'Scan to verify — instant authentication',
  'brandStory.solution.feature2.point3': 'Sold only through official authorized channels',
  'brandStory.solution.feature2.point4': 'Batch-tracked from Seoul factory to your door',
  'brandStory.solution.feature3.title': 'Simplified Routine',
  'brandStory.solution.feature3.point1': '3 steps — no confusion, no 10-step overwhelm',
  'brandStory.solution.feature3.point2': "Designed for Bangladesh's tropical climate",
  'brandStory.solution.feature3.point3': 'Works in Dhaka humidity and monsoon season',
  'brandStory.solution.feature3.point4': 'Effective concentrations, not marketing hype',
  'brandStory.madeFor.label': 'Formulated For You',
  'brandStory.madeFor.heading': 'Formulated for South Asian Skin',
  'brandStory.madeFor.p1': 'South Asian skin has unique characteristics that most generic K-Beauty brands ignore. Higher melanin content means different pigmentation patterns. Tropical humidity demands lightweight, non-comedogenic textures. And the constant battle against UV damage requires ingredients that work deeper than surface-level brightening.',
  'brandStory.madeFor.p2': "We selected every ingredient in the Rx.K Seoul routine specifically for these concerns. Niacinamide 5% targets hyperpigmentation at the cellular level. Niacinamide 2% with PHA/LHA provides multi-layer hydration without heaviness. Ceramide NP rebuilds the barrier that Dhaka's humidity and pollution constantly compromise.",
  'brandStory.madeFor.cta': 'Discover the 3-Step Treatment →',
  'brandStory.madeFor.concern1.title': 'Tropical Sun Damage',
  'brandStory.madeFor.concern1.desc': 'Hyperpigmentation and dark spots from year-round UV exposure',
  'brandStory.madeFor.concern2.title': 'Humidity & Pollution',
  'brandStory.madeFor.concern2.desc': "Barrier damage and clogged pores in Dhaka's urban environment",
  'brandStory.madeFor.concern3.title': 'Uneven Skin Tone',
  'brandStory.madeFor.concern3.desc': 'Post-inflammatory pigmentation common in melanin-rich skin',
  'brandStory.madeFor.concern4.title': 'Barrier Sensitivity',
  'brandStory.madeFor.concern4.desc': 'Compromised skin barriers from harsh products and climate stress',
  'brandStory.company.label': 'Our Parent Company',
  'brandStory.company.heading': 'Backed by The.K Seoul Co., Ltd.',
  'brandStory.company.p1': 'The.K Seoul Co., Ltd. is a Korean beauty company founded with a mission to bring pharmaceutical-grade skincare to markets that need it most. Our Seoul-based R&D team works alongside Korean dermatologists and pharmacists to develop formulations that meet both Korean pharmaceutical standards and the specific needs of tropical climates.',
  'brandStory.company.p2': 'Every batch is manufactured in GMP-certified Korean facilities, undergoes rigorous quality control, and is dermatologically tested before leaving the factory. When you use Rx.K Seoul, you are using the same standards that Korean pharmacies demand.',
  'brandStory.company.signatureName': 'Jack Daniel',
  'brandStory.company.signatureCaption': 'Jack Daniel, The.K Seoul Co., Ltd.',
  'brandStory.company.stat1': 'KOREA',
  'brandStory.company.stat1Label': 'Made in Korea',
  'brandStory.company.stat2': 'GMP',
  'brandStory.company.stat2Label': 'GMP Certified',
  'brandStory.company.stat3': 'TESTED',
  'brandStory.company.stat3Label': 'Dermatologically Tested',
  'brandStory.cta.heading': 'Experience Prescribed Beauty',
  'brandStory.cta.body': "Join Bangladesh's first community of prescription K-Beauty users. Clinical ingredients, Korean innovation, authentic results — starting from ৳2,500.",
  'brandStory.cta.downloadBrochure': 'Download Brochure',

  // ===== 3-STEP TREATMENT =====
  'threeStep.hero.label': 'Daily Ritual',
  'threeStep.hero.heading': '3-Step Daily Treatment',
  'threeStep.hero.subtitle': 'Your daily prescription for beautiful skin. Open · Treat · Lock.',
  'threeStep.philosophy.label': 'The Philosophy',
  'threeStep.philosophy.heading': 'Why 3 Steps?',
  'threeStep.philosophy.p1': "K-Beauty is famous for its elaborate 10-step routines. But here's what dermatologists know: most of those steps are optional. The science of skincare comes down to three essential actions that every skin type needs, every single day.",
  'threeStep.philosophy.prep': 'Prep',
  'threeStep.philosophy.prepDesc': 'replenish water content in the skin barrier.',
  'threeStep.philosophy.treat': 'Treat',
  'threeStep.philosophy.treatDesc': 'deliver active ingredients that target specific concerns.',
  'threeStep.philosophy.seal': 'Seal',
  'threeStep.philosophy.sealDesc': 'seal in the actives and defend against environmental damage.',
  'threeStep.philosophy.p2': 'Rx.K Seoul distills clinical dermatology into a routine anyone can follow — morning and evening, in under 5 minutes. No confusion, no overwhelm, just prescribed results.',
  'threeStep.step01.badge': 'OPEN',
  'threeStep.step01.name': 'Skin Priming Booster Essence',
  'threeStep.step01.subtitle': 'Prep. Brighten. Boost.',
  'threeStep.step01.price': '৳2,500',
  'threeStep.step01.volume': '50ml',
  'threeStep.step01.desc': 'The essential first step. Niacinamide 2% brightens and evens skin tone while PHA/LHA gently exfoliates surface dead cells for a smoother canvas. Hyaluronic Acid delivers multi-layer hydration, and Centella Asiatica calms inflammation and supports healing. Your skin is now primed, brightened, and ready for treatment.',
  'threeStep.step01.ingredientsLabel': 'Key Ingredients',
  'threeStep.step01.howToUse': 'How to Use',
  'threeStep.step01.use1': 'After cleansing, apply to damp skin',
  'threeStep.step01.use2': 'Dispense 2-3 pumps into palms',
  'threeStep.step01.use3': 'Gently pat over face and neck',
  'threeStep.step01.use4': 'Wait 30 seconds before Step 02',
  'threeStep.step01.cta': 'Shop Skin Priming Booster Essence →',
  'threeStep.step02.badge': 'TREAT',
  'threeStep.step02.name': 'Daily Rescue Serum',
  'threeStep.step02.subtitle': 'Repair. Strengthen. Restore.',
  'threeStep.step02.price': '৳2,800',
  'threeStep.step02.volume': '50ml',
  'threeStep.step02.desc': 'The treatment powerhouse. Niacinamide 5% targets dark spots, post-inflammatory hyperpigmentation, and uneven tone at the cellular level. Tranexamic Acid 1-2% clinically reduces melasma and PIH. Peptide accelerates skin repair and boosts collagen. Ceramide NP reinforces the lipid barrier for stronger, more resilient skin.',
  'threeStep.step02.ingredientsLabel': 'Key Ingredients',
  'threeStep.step02.howToUse': 'How to Use',
  'threeStep.step02.use1': 'After Skin Priming Booster Essence fully absorbs',
  'threeStep.step02.use2': 'Press pump once for a single dose',
  'threeStep.step02.use3': 'Apply evenly to face and neck',
  'threeStep.step02.use4': 'Allow 60 seconds of absorption',
  'threeStep.step02.use5': 'Proceed to Step 03 immediately after',
  'threeStep.step02.cta': 'Shop Daily Rescue Serum →',
  'threeStep.step03.badge': 'LOCK',
  'threeStep.step03.name': 'Barrier Seal Cream',
  'threeStep.step03.subtitle': 'Seal. Protect. Maintain.',
  'threeStep.step03.price': '৳3,200',
  'threeStep.step03.volume': '50ml',
  'threeStep.step03.desc': "The protective final step. Ceramide NP rebuilds your skin's lipid barrier — the same barrier that Dhaka's humidity and pollution constantly compromise. Squalane, a non-comedogenic emollient, seals in all the actives from Step 02 without clogging pores. Coco-Caprylate/Caprate delivers silky moisture without heaviness or greasiness.",
  'threeStep.step03.ingredientsLabel': 'Key Ingredients',
  'threeStep.step03.howToUse': 'How to Use',
  'threeStep.step03.use1': 'After serum has fully absorbed (60s)',
  'threeStep.step03.use2': 'Take a pea-sized amount, warm between fingertips',
  'threeStep.step03.use3': 'Press gently into face and neck — do not rub',
  'threeStep.step03.use4': 'Extend to décolletage for extra protection',
  'threeStep.step03.use5': 'Wait 3 minutes before sunscreen or makeup',
  'threeStep.step03.cta': 'Shop Barrier Seal Cream →',
  'threeStep.climate.label': 'Climate Guide',
  'threeStep.climate.heading': "Adapted for Bangladesh's Climate",
  'threeStep.climate.hot.title': 'Hot & Humid',
  'threeStep.climate.hot.subtitle': 'March – October',
  'threeStep.climate.hot.tip1': 'Use a lighter amount of Barrier Seal Cream — skin produces more sebum in humidity',
  'threeStep.climate.hot.tip2': 'Niacinamide 2% and PHA/LHA in Skin Priming Booster Essence draw ambient moisture from humid air for extra radiance',
  'threeStep.climate.hot.tip3': 'Always apply sunscreen after Step 3. UV exposure is highest during these months',
  'threeStep.climate.hot.tip4': 'Store products in a cool, dry place away from direct sunlight',
  'threeStep.climate.hot.tip5': 'If skin feels oily by midday, blot gently — do not over-wash',
  'threeStep.climate.cool.title': 'Cool & Dry',
  'threeStep.climate.cool.subtitle': 'November – February',
  'threeStep.climate.cool.tip1': 'Apply a generous layer of Skin Priming Booster — dry air increases transepidermal water loss',
  'threeStep.climate.cool.tip2': 'Use the full recommended amount of Barrier Seal Cream to lock in moisture overnight',
  'threeStep.climate.cool.tip3': 'Daily Rescue Serum works exceptionally well for overnight repair during cooler nights',
  'threeStep.climate.cool.tip4': 'Consider adding a humidifier in your bedroom for extra environmental hydration',
  'threeStep.climate.cool.tip5': 'Increase Barrier Seal Cream on dry patches (cheeks, around nose)',
  'threeStep.timeline.label': 'Expected Results',
  'threeStep.timeline.heading': 'Results Timeline',
  'threeStep.timeline.m1.period': '3 Days',
  'threeStep.timeline.m1.title': 'Noticeably More Hydrated',
  'threeStep.timeline.m1.desc': 'Your skin feels softer, smoother, and more comfortable. Niacinamide 2% and PHA/LHA begin brightening and smoothing surface texture immediately.',
  'threeStep.timeline.m2.period': '2 Weeks',
  'threeStep.timeline.m2.title': 'Smoother, More Even Texture',
  'threeStep.timeline.m2.desc': 'Pores appear refined. Skin texture is visibly smoother. Niacinamide 5% and Tranexamic Acid begin regulating sebum and fading pigmentation.',
  'threeStep.timeline.m3.period': '4-6 Weeks',
  'threeStep.timeline.m3.title': 'Visible Reduction in Dark Spots',
  'threeStep.timeline.m3.desc': 'Post-inflammatory hyperpigmentation fades. Skin tone is more even and luminous. The Ceramide NP and Squalane barrier is stronger, making skin more resilient.',
  'threeStep.faq.label': 'FAQ',
  'threeStep.faq.heading': 'Common Questions',
  'threeStep.faq.q1': 'Do I need all 3 steps, or can I just use one?',
  'threeStep.faq.a1': 'Each step serves a distinct purpose. Step 01 (Skin Priming Booster Essence) hydrates and preps the skin. Step 02 (Daily Rescue Serum) delivers active treatment ingredients. Step 03 (Barrier Seal Cream) seals everything in and protects. Using all three together creates a synergistic effect where each step enhances the next. However, if you are just starting out, begin with Step 01 and gradually add the others as your skin adjusts.',
  'threeStep.faq.q2': 'How long before I see visible results?',
  'threeStep.faq.a2': 'Hydration improvement is immediate — you will feel the difference after the first application. Texture and tone improvements typically appear within 2 weeks. Dark spot reduction and significant pigmentation fading require 4–6 weeks of consistent use, as Niacinamide works at the cellular level. Individual results vary based on skin condition, climate, and consistency.',
  'threeStep.faq.q3': 'Is this routine suitable for sensitive skin?',
  'threeStep.faq.a3': 'Yes. All three products are formulated without common irritants: no artificial fragrances, no alcohol denat, no essential oils, and no harsh exfoliants. Niacinamide 5% with Tranexamic Acid and Peptide is well-tolerated by most skin types, including sensitive skin. If you are highly reactive, we recommend starting with Step 01 for one week before adding Step 02, then Step 03. Always patch test behind your ear for 48 hours before full-face use.',
  'threeStep.faq.q4': 'Can men use this routine too?',
  'threeStep.faq.a4': 'Absolutely. Skin is skin, regardless of gender. Men often have thicker, oilier skin and larger pores — the Niacinamide in Step 02 is particularly beneficial for regulating excess sebum and refining pore appearance. Many of our early adopters in Dhaka are men who wanted a simple, effective routine without the complexity of traditional K-Beauty.',
  'threeStep.faq.q5': 'What if I already use other products?',
  'threeStep.faq.a5': 'Rx.K Seoul is designed to replace your current core routine. You can continue using sunscreen (essential) and a gentle cleanser. Avoid mixing with other high-concentration actives like Vitamin C, Retinol, or AHAs/BHAs in the same routine — alternate them with our 3-Step Treatment (e.g., use actives on Monday, Rx.K Seoul on Tuesday).',
  'threeStep.cta.heading': 'Get the Complete 3-Step Set',
  'threeStep.cta.price': '৳8,000',
  'threeStep.cta.originalPrice': '৳8,500',
  'threeStep.cta.save': 'Save ৳500',
  'threeStep.cta.desc': 'Skin Priming Booster Essence (50ml) + Daily Rescue Serum (50ml) + Barrier Seal Cream (50ml). Everything you need for your daily prescription.',
  'common.buyNow': 'Buy Now',
  'threeStep.buy.setLabel': 'The complete 3-step set',
  'threeStep.buy.giftBox': 'Gift box included',
  'threeStep.buy.cod': 'Cash on delivery',
  'threeStep.buy.madeInKorea': 'Made in Korea',

  // ===== PRODUCTS =====
  'products.hero.label': 'Products',
  'products.hero.heading': 'The Prescription Collection',
  'products.hero.subtitle': 'Clinical-grade formulations, pharmacist-curated for Bangladesh.',
  'products.hero.cta': 'Shop the 3-Step Set',
  'products.allProducts': 'All Products',
  'products.categories': 'Categories',
  'products.step01': 'Step 01 — OPEN',
  'products.step02': 'Step 02 — TREAT',
  'products.step03': 'Step 03 — LOCK',
  'products.set': '3-Step Set',
  'products.viewDetails': 'View Details',
  'products.ingredients': 'Key Ingredients',
  'products.howToUse': 'How to Use',
  'products.clinicalClaims': 'Clinical Claims',
  'products.suggestedUse': 'Suggested Use',
  'products.size': 'Size',
  'products.relatedProducts': 'Related Products',
  'products.fullRoutine': 'Full Routine',
  'products.seeAll': 'See All Products',

  // ===== VERIFY =====
  'verify.hero.label': 'Authentication',
  'verify.hero.heading': 'Verify Your Product',
  'verify.hero.subtitle': 'Scan the QR code on your product to confirm authenticity and view batch details.',
  'verify.instruction.title': 'How to Verify',
  'verify.instruction.step1': 'Locate the QR code sticker on your product box.',
  'verify.instruction.step2': 'Scan with any QR reader or camera app.',
  'verify.instruction.step3': 'View batch number, manufacturing date, and authenticity status.',
  'verify.instruction.step4': 'Contact us if verification fails — we guarantee every product.',
  'verify.demo.title': 'Sample Verification Results',
  'verify.demo.product': 'Product',
  'verify.demo.batch': 'Batch',
  'verify.demo.status': 'Status',
  'verify.demo.date': 'Mfg. Date',
  'verify.demo.authentic': 'Authentic',
  'verify.input.label': 'Product Code',
  'verify.input.placeholder': 'e.g. XXXX-XXXX-XXXX',
  'verify.input.button': 'Verify',
  'verify.input.checking': 'Checking…',
  'verify.result.authentic.title': 'Authentic Product',
  'verify.result.authentic.body': 'This code is on file — {{product}} is a genuine Rx.K Seoul product.',
  'verify.result.authentic.firstVerified': 'First verified',
  'verify.result.field.product': 'Product Name',
  'verify.result.field.batch': 'Batch Number',
  'verify.result.field.mfgDate': 'Manufacturing Date',
  'verify.result.field.expiryDate': 'Expiry Date',
  'verify.result.field.firstScan': 'First Scan',
  'verify.result.field.scanCount': 'Number of Scans',
  'verify.result.field.company': 'Company',
  'verify.result.field.companyValue': 'The.K Seoul',
  'verify.result.suspicious.title': 'Scanned Multiple Times',
  'verify.result.suspicious.body': 'This code has already been scanned multiple times. Please contact customer support if you suspect counterfeit.',
  'verify.result.serial.title': 'This Is the Box Serial Number',
  'verify.result.serial.body': '{{code}} is the stock number printed under the barcode — it is not a verification code. To check your product, scan the QR code on the silver hologram sticker (marked “Scan to Verify”) with your phone camera.',
  'verify.result.notfound.title': 'This Is a Fake Product',
  'verify.result.notfound.body': "This code doesn't match any genuine The.K Seoul product in our system — this is a counterfeit item, not a real product from us. Please stop using it immediately and contact our customer support so we can help.",
  'verify.result.error': 'Something went wrong — please try again.',
  'verify.trust.title': 'Why Authenticity Matters',
  'verify.trust.body': 'Counterfeit cosmetics can contain harmful ingredients. Rx.K Seoul guarantees every product through our QR verification system, batch tracking, and authorized sales channels only.',
  'verify.cta': 'Shop with Confidence',

  // ===== WHERE TO BUY =====
  'whereToBuy.hero.label': 'Retailers',
  'whereToBuy.hero.heading': 'Where to Buy',
  'whereToBuy.hero.subtitle': 'Find Rx.K Seoul at authorized pharmacies and online stores across Bangladesh.',
  'whereToBuy.online.title': 'Official Online Store',
  'whereToBuy.online.subtitle': 'Free delivery on orders over ৳3,000. QR-verified authentic products.',
  'whereToBuy.online.cta': 'Shop Now →',
  'whereToBuy.pharmacy.title': 'Authorized Pharmacies',
  'whereToBuy.pharmacy.subtitle': 'Visit our partner pharmacies for in-person consultation and purchase.',
  'whereToBuy.retail.title': 'Retail Partners',
  'whereToBuy.retail.subtitle': 'Select retail locations carrying Rx.K Seoul products.',
  'whereToBuy.map.title': 'Store Locator',
  'whereToBuy.map.subtitle': 'Find the nearest authorized retailer in your area.',
  'whereToBuy.trust.title': '100% Authentic Guarantee',
  'whereToBuy.trust.body': 'All products sold through authorized channels include QR verification and batch tracking. If you suspect a counterfeit, report it immediately.',
  'whereToBuy.filter.all': 'All',
  'whereToBuy.filter.pharmacy': 'Pharmacy',
  'whereToBuy.filter.online': 'Online',
  'whereToBuy.filter.retail': 'Retail',

  // ===== CONTENT =====
  'content.hero.label': 'Knowledge',
  'content.hero.heading': 'Skincare Intelligence',
  'content.hero.subtitle': 'Evidence-based skincare knowledge from our pharmacists and researchers.',
  'content.categories': 'Categories',
  'content.allArticles': 'All Articles',
  'content.readTime': 'min read',
  'content.author': 'By',
  'content.published': 'Published',
  'content.relatedArticles': 'Related Articles',
  'content.backToHub': 'Back to Content Hub',

  // ===== ABOUT =====
  'about.hero.label': 'About',
  'about.hero.heading': 'About Rx.K Seoul',
  'about.mission.label': 'Our Mission',
  'about.mission.heading': 'Beauty, Prescribed.',
  'about.mission.body': 'We believe effective skincare should not be a luxury or a gamble. Every Rx.K Seoul product is developed with the rigor of pharmaceutical science and the elegance of Korean beauty innovation.',
  'about.values.label': 'Our Values',
  'about.values.heading': 'What We Stand For',

  // ===== CONTACT =====
  'contact.hero.label': 'Contact',
  'contact.hero.heading': "We're here to help",
  'contact.form.name': 'Name',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Phone',
  'contact.form.subject': 'Subject',
  'contact.form.message': 'Message',
  'contact.form.submit': 'Send Inquiry',
  'contact.form.success': 'Thank you! We will get back to you within 24 hours.',
  'contact.info.title': 'Contact Information',
  'contact.info.email': 'Email',
  'contact.info.phone': 'Phone',
  'contact.info.address': 'Address',
  'contact.info.hours': 'Business Hours',

  // ===== FAQ =====
  'faq.hero.label': 'Support',
  'faq.hero.heading': 'Frequently Asked Questions',
  'faq.hero.subtitle': 'Answers from our pharmacist team.',

  // FAQ Group Titles
  'faq.groupA.title': 'Product Usage',
  'faq.groupB.title': 'Authenticity & Verification',
  'faq.groupC.title': 'Shipping & Returns',
  'faq.groupD.title': 'Pharmacy Partnership',

  // Group A — Product Usage
  'faq.groupA.q1.question': 'How long until I see results?',
  'faq.groupA.q1.answer': 'First hydration improvements: ~3 days. Smoother texture: ~2 weeks. Visible reduction in dark spots: 4–6 weeks. Consistency matters more than quantity.',
  'faq.groupA.q2.question': 'Can I use Rx.K Seoul with my existing skincare?',
  'faq.groupA.q2.answer': 'Yes. The 3-Step routine replaces toner / essence / serum / moisturizer in most regimens. Continue using sunscreen separately (SPF 30+ daily).',
  'faq.groupA.q3.question': 'Is the routine safe during pregnancy?',
  'faq.groupA.q3.answer': 'All three products avoid retinoids and high-percentage actives flagged as pregnancy-cautious. Consult your obstetrician before adding any new skincare during pregnancy.',
  'faq.groupA.q4.question': 'Can men use Rx.K Seoul?',
  'faq.groupA.q4.answer': 'Yes. The formulas are dermatologically tested and non-comedogenic, suitable for all adult skin.',
  'faq.groupA.q5.question': 'How much product per application?',
  'faq.groupA.q5.answer': 'Booster: 2–3 pumps. Serum: 1 pump. Cream: pea-sized.',

  // Group B — Authenticity & Verification
  'faq.groupB.q1.question': 'How do I verify my product is genuine?',
  'faq.groupB.q1.answer': 'Every Rx.K Seoul box has a unique QR code on the back. Scan it on the /verify page to see batch number, manufacturing date, and authorized retailer. If verification fails, contact us immediately.',
  'faq.groupB.q2.question': 'I bought online and the QR does not work — what should I do?',
  'faq.groupB.q2.answer': 'Submit a counterfeit report on the /contact page with the seller name, purchase date, and a photo of the box and QR. We investigate every report within 48 hours.',
  'faq.groupB.q3.question': 'Where are the safest places to buy Rx.K Seoul?',
  'faq.groupB.q3.answer': 'Our official online store and the authorized pharmacy partners listed on the /buy page. On online marketplaces (Daraz Mall and similar), only buy when the seller is "The.K Seoul Co., Ltd." or an authorized partner.',

  // Group C — Shipping & Returns
  'faq.groupC.q1.question': 'How long does delivery take?',
  'faq.groupC.q1.answer': 'Dhaka: 1–2 business days. Other Bangladesh cities: 2–4 business days.',
  'faq.groupC.q2.question': 'Is shipping free?',
  'faq.groupC.q2.answer': 'Yes, on orders over ৳3,000. Below ৳3,000, a flat ৳120 fee applies.',
  'faq.groupC.q3.question': 'Can I return a product?',
  'faq.groupC.q3.answer': 'Unopened products can be returned within 7 days of delivery. Opened skincare cannot be returned for hygiene reasons unless defective. Contact us for assistance.',
  'faq.groupC.q4.question': 'How do mileage rewards work?',
  'faq.groupC.q4.answer': 'Earn 10% back as Rx.K Points on every order. Redeem at checkout (1 Point = ৳1).',

  // Group D — Pharmacy Partnership
  'faq.groupD.q1.question': 'How do I become an authorized retailer?',
  'faq.groupD.q1.answer': 'Apply at /partner-apply. Our Country Sales Director (Selim Reza) will respond within 5 business days with margin terms, POSM support, and initial order details.',
  'faq.groupD.q2.question': 'What margins do partners earn?',
  'faq.groupD.q2.answer': 'Standard pharmacy margin terms apply, with additional point-of-sale push incentives. Details shared during the partnership conversation.',
  'faq.groupD.q3.question': 'Do you provide point-of-sale materials?',
  'faq.groupD.q3.answer': 'Yes — counter displays, sample sachets, pharmacist training brochures, and ingredient reference cards.',

  // ===== SHIPPING & RETURNS =====
  'shipping.hero.label': 'Policy',
  'shipping.hero.heading': 'Shipping & Returns',
  'shipping.dhaka.title': 'Dhaka Delivery',
  'shipping.dhaka.desc': 'Standard delivery. Delivery charge {{price}}.',
  'shipping.dhaka.time': '5 Business Days',
  'shipping.outside.title': 'Outside Dhaka',
  'shipping.outside.desc': 'Standard delivery. Delivery charge {{price}}.',
  'shipping.outside.time': '10 Business Days',
  'shipping.free.title': 'Free Shipping',
  'shipping.free.desc': 'Free delivery on all orders over {{threshold}}.',
  'shipping.returns.title': 'Return Policy',
  'shipping.returns.desc': 'Unopened products may be returned within 14 days of delivery. opened products are not eligible for return due to hygiene reasons.',
  'shipping.track.title': 'Order Tracking',
  'shipping.track.desc': 'All orders include tracking via SMS and email updates.',

  // ===== PRIVACY POLICY =====
  'privacy.hero.label': 'Legal',
  'privacy.hero.heading': 'Privacy Policy',
  'privacy.lastUpdated': 'Last updated: May 2026',

  // ===== TERMS OF SERVICE =====
  'terms.hero.label': 'Legal',
  'terms.hero.heading': 'Terms of Service',
  'terms.lastUpdated': 'Last updated: May 2026',

  // ===== CART / CHECKOUT / ORDER =====
  'cart.yourCart': 'Your Cart',
  'cart.empty': 'Your cart is empty',
  'cart.removed': 'Removed from cart',
  'cart.added': 'Added to Cart ✓',
  'cart.viewCart': 'View Cart →',
  'cart.subtotal': 'Subtotal',
  'cart.shipping': 'Shipping',
  'cart.shippingCalculated': 'Calculated at checkout',
  'cart.free': 'Free',
  'cart.total': 'Total',
  'checkout.title': 'Checkout',
  'checkout.contact': 'Contact Information',
  'checkout.contactShipping': 'Contact & Shipping',
  'checkout.fullName': 'Full Name',
  'checkout.phone': 'Phone',
  'checkout.email': 'Email (Optional)',
  'checkout.shipping': 'Shipping Address',
  'checkout.address1': 'Full Address',
  'checkout.address2': 'Address Line 2 (Optional)',
  'checkout.selectDistrict': 'Select District',
  'checkout.selectThana': 'Select Thana',
  'checkout.searchDistrict': 'Search district…',
  'checkout.searchThana': 'Search thana…',
  'checkout.postalCode': 'Postal Code (Optional)',
  'checkout.deliveryNote': 'Delivery Note',
  'checkout.addDeliveryNote': 'Add a delivery note',
  'checkout.deliveryNotePlaceholder': 'Any special instructions for delivery (optional)',
  'checkout.payment': 'Payment Method',
  'checkout.cod': 'Cash on Delivery',
  'checkout.comingSoon': 'Coming Soon',
  'checkout.orderSummary': 'Order Summary',
  'checkout.agreePrefix': 'I have read and agree to the',
  'checkout.termsLink': 'Terms & Conditions',
  'checkout.privacyLink': 'Privacy Policy',
  'checkout.agreeAnd': 'and',
  'checkout.returnsLink': 'Return & Refund Policy',
  'checkout.freeShippingNote': 'Free shipping on orders over ৳{{threshold}}',
  'checkout.haveCoupon': 'Have a coupon code?',
  'checkout.couponPlaceholder': 'Enter code',
  'checkout.apply': 'Apply',
  'checkout.remove': 'Remove',
  'checkout.discount': 'Discount',
  'checkout.comboDiscount': 'Combo Discount',
  'checkout.giftBox': 'Add a Gift Box',
  'checkout.giftBoxIncluded': 'Gift Box Included',
  'checkout.couponApplied': 'Coupon applied',
  'checkout.authenticityGuaranteed': 'Authenticity Guaranteed',
  'checkout.secureCheckout': 'Secure Checkout',
  'order.thankYou': 'Thank you for your order!',
  'order.orderId': 'Order ID',
  'order.estimatedDelivery': 'Estimated delivery',
  'order.businessDays': 'business days',
  'order.outsideDhaka': 'Outside Dhaka',
  'order.orderDetails': 'Order Details',
  'order.notFound': 'Order not found',
  'order.authenticityGuaranteed': 'Authenticity Guaranteed',
  'order.verifyQR': 'Verify with QR',
  'order.invoice': 'Invoice',
  'order.invoiceFrom': 'From',
  'order.invoiceTo': 'To',
  'order.description': 'Description',
  'order.qty': 'Qty',
  'order.unitPrice': 'Unit Price',
  'order.amount': 'Amount',
  'order.tax': 'Tax',
  'order.paymentTerms': 'Payment Terms',
  'order.notes': 'Notes',
  'stickyBar.product': '3-Step Daily Treatment Set',
  'stickyBar.save': '(Save ৳500)',
  'home.hero.ctaShopSet': 'SHOP THE 3-STEP SET — ৳8,000\n(SAVE ৳500)',

  // ===== COMMON ADDITIONS =====
  'common.select': 'Select',
  'common.submitting': 'Submitting...',
  'common.max': 'characters max',

  // ===== PRODUCT DETAIL ADDITIONS =====
  'products.clickToZoom': 'Click to zoom',
  'products.sizeGuide': 'Size Guide',
  'products.realSize': 'Real size',
  'products.sizeGuideDesc': 'Actual product size compared to average adult palm for reference.',
  'products.howToUseVideo': 'How to Use — Video Tutorial',
  'products.watchTutorial': 'Watch the application tutorial',
  'products.ingredientScience': 'Ingredient Science',
  'products.inciName': 'INCI Name',
  'products.clinicalEvidence': 'Clinical Evidence',
  'products.benefit': 'Key Benefit',
  'products.clinicalResults': 'Clinical Study Results',
  'products.clinicalSubtitle': 'Based on 8-week clinical study',
  'products.week4': '4 Weeks',
  'products.week8': '8 Weeks',
  'products.clinicalDisclaimer': 'Based on 8-week clinical study, n=42 subjects. Individual results may vary.',
  'products.reviews': 'Reviews',
  'products.verifiedPurchases': 'Verified Purchases',
  'products.filterAll': 'All',
  'products.filterPhotos': 'Photos Only',
  'products.verified': 'Verified Purchase',
  'products.productFAQ': 'Product Q&A',
  'products.askQuestion': 'Ask a question about this product',
  'products.loginToAsk': 'Log in to ask a question',
  'products.questionPlaceholder': 'What would you like to know about this product?',
  'products.submitQuestion': 'Submit Question',
  'products.questionSubmitted': 'Thanks! We\'ll answer your question in My Account → Q&A.',
  'products.questionSubmitError': 'Could not submit your question. Please try again.',
  'products.crossSell': 'Complete Your Routine',
  'products.writeReview': 'Write a Review',
  'products.yourRating': 'Your Rating',
  'products.yourSkinType': 'Your Skin Type (optional)',
  'products.selectSkinType': 'Select skin type',
  'products.reviewPlaceholder': 'Share your experience with this product…',
  'products.submitReview': 'Submit Review',
  'products.loginToReview': 'Log in to write a review',
  'products.reviewSubmitted': 'Thank you! Your review has been submitted for approval.',
  'products.reviewSubmitError': 'Could not submit your review. Please try again.',
  'products.reviewPending': 'Your review has been submitted and is awaiting approval.',
  'products.reviewRejected': 'Your review was not approved for publication.',

  // ===== WHERE TO BUY ADDITIONS =====
  'whereToBuy.officialStore': 'Official Online Store',
  'whereToBuy.shopDirect': 'Shop direct from rxk.thekseoul.com',
  'whereToBuy.shopNow': 'Shop Now →',
  'whereToBuy.comingSoon': 'Coming Soon',
  'whereToBuy.mapPlaceholder': 'Map integration coming soon. Below are our key partner areas.',
  'whereToBuy.poweredBy': 'Powered by Google Maps (integration coming soon)',
  'whereToBuy.searchPlaceholder': 'Search by area or pharmacy name',
  'whereToBuy.filterArea': 'Area',
  'whereToBuy.filterType': 'Type',
  'whereToBuy.showingResults': 'Showing {{count}} of {{total}} stores',
  'whereToBuy.partnerApply': 'Become a Partner',
  'whereToBuy.partnerApplyDesc': 'Interested in carrying Rx.K Seoul at your pharmacy or retail location?',
  'whereToBuy.applyNow': 'Apply Now →',
  'whereToBuy.authenticityGuaranteed': '✓ Authenticity Guaranteed',
  'whereToBuy.qrVerify': 'Scan QR on product box to verify authenticity instantly.',
  'whereToBuy.morePartners.title': 'More Partners Coming Soon',
  'whereToBuy.morePartners.desc': 'Authorized pharmacy partners are being onboarded across Bangladesh',
  'whereToBuy.morePartners.cta': 'Apply to Become a Partner →',
  'whereToBuy.authorizedPartners.heading': 'Authorized Pharmacy Partners — Coming Late June 2026',
  'whereToBuy.authorizedPartners.description':
    'We are onboarding partner pharmacies across Dhaka, Chittagong, and Sylhet. The complete list of authorized retailers will be published in late June 2026, in time for our official Bangladesh launch on July 1, 2026. To express interest as a pharmacy partner, apply below.',
  'whereToBuy.authorizedPartners.button': 'Apply to Become a Partner →',
  'whereToBuy.showingOne': 'Showing 1 store',
  'whereToBuy.reportCounterfeit': 'Spotted a suspicious product? Report a counterfeit here.',
  'whereToBuy.reportLink': 'Submit a report →',

  // ===== PARTNER APPLY =====
  'partnerApply.hero.label': 'Partners',
  'partnerApply.hero.heading': 'Become a Rx.K Seoul Partner',
  'partnerApply.hero.subtitle': 'Join our authorized retail network and bring pharmacist-recommended K-Beauty to your customers.',
  'partnerApply.form.businessName': 'Business Name',
  'partnerApply.form.businessType': 'Business Type',
  'partnerApply.form.typePharmacy': 'Pharmacy',
  'partnerApply.form.typeBeauty': 'Beauty Retail',
  'partnerApply.form.typeOnline': 'Online Store',
  'partnerApply.form.typeDistributor': 'Distributor',
  'partnerApply.form.contactPerson': 'Contact Person',
  'partnerApply.form.email': 'Email',
  'partnerApply.form.phone': 'Phone',
  'partnerApply.form.address': 'Business Address',
  'partnerApply.form.mapLink': 'Google Maps Link (optional)',
  'partnerApply.form.mapLinkHint': 'Search your business on Google Maps, tap Share, and paste the link',
  'partnerApply.form.drugLicenseNo': 'Drug License Number',
  'partnerApply.form.tinNo': 'TIN Number',
  'partnerApply.form.nidNo': 'NID Number',
  'partnerApply.form.binNo': 'BIN Number (optional)',
  'partnerApply.form.city': 'City',
  'partnerApply.form.cityDhaka': 'Dhaka',
  'partnerApply.form.cityChittagong': 'Chittagong',
  'partnerApply.form.citySylhet': 'Sylhet',
  'partnerApply.form.cityOthers': 'Others',
  'partnerApply.form.volume': 'Monthly Volume Estimate',
  'partnerApply.form.volume1': '< 100 units',
  'partnerApply.form.volume2': '100–500 units',
  'partnerApply.form.volume3': '500–1000 units',
  'partnerApply.form.volume4': '1000+ units',
  'partnerApply.form.whyPartner': 'Why partner with us?',
  'partnerApply.form.whyPlaceholder': 'Tell us about your business and why you want to partner (optional)',
  'partnerApply.form.documentsTitle': 'Required Documents',
  'partnerApply.form.docDrugLicense': 'Drug License',
  'partnerApply.form.docTin': 'TIN Certificate',
  'partnerApply.form.docNid': 'NID',
  'partnerApply.form.docPhoto': "Applicant's Photo",
  'partnerApply.form.docBin': 'BIN Certificate (optional)',
  'partnerApply.form.docBankSolvency': 'Bank Solvency Certificate (optional)',
  'partnerApply.form.docBankStatement': '6-Month Bank Statement (optional)',
  'partnerApply.form.chooseFile': 'Choose file',
  'partnerApply.form.submit': 'Submit Application',
  'partnerApply.benefits.title': 'Benefits of Partnering',
  'partnerApply.benefits.brandSupport': 'Official brand support & marketing materials',
  'partnerApply.benefits.training': 'Product training provided by our team',
  'partnerApply.benefits.exclusive': 'Exclusive territory protection',
  'partnerApply.benefits.margin': 'Competitive wholesale margins',
  'partnerApply.success.title': 'Application Submitted',
  'partnerApply.success.body': 'Thank you for your interest. Our partnership team will review your application and contact you within 3 business days.',
  'partnerApply.success.back': 'Back to Where to Buy',

  // ===== HOME NAVBAR =====
  'home.nav.brandStory': 'Brand Story',
  'home.nav.routine': 'Routine',
  'home.nav.products': 'Products',
  'home.nav.whereToBuy': 'Where to Buy',
  'home.nav.ourProducts': 'Our Products',
  'home.nav.menuOpen': 'Open menu',

  // ===== HOME FOOTER =====
  'home.footer.brand': 'Brand',
  'home.footer.products': 'Products',
  'home.footer.contact': 'Contact',
  'home.footer.brandStory': 'Brand Story',
  'home.footer.philosophy': 'Philosophy',
  'home.footer.ingredientResearch': 'Ingredient Research',
  'home.footer.sustainability': 'Sustainability',
  'home.footer.step01': 'Step 01 — Booster Essence',
  'home.footer.step02': 'Step 02 — Daily Rescue Serum',
  'home.footer.step03': 'Step 03 — Barrier Seal Cream',
  'home.footer.routineGuide': 'Routine Guide',
  'home.footer.email': 'hello@rxkseoul.com',
  'home.footer.kakao': 'Kakao Channel: @rxkseoul',
  'home.footer.address': 'Seoul, Gangnam-gu',
  'home.footer.whereToBuy': 'Where to Buy →',
  'home.footer.privacy': 'Privacy Policy',
  'home.footer.terms': 'Terms of Service',
  'home.footer.madeInKorea': 'MADE IN KOREA',

  // ===== HOME WHERE TO BUY SECTION =====
  'home.whereToBuySection.label': 'Purchase',
  'home.whereToBuySection.heading': 'Where to Buy',
  'home.whereToBuySection.desc': 'Available online and offline. Meet Rx.K Seoul.',
  'home.whereToBuySection.seeAll': 'See All',

  // ===== HOME CTA SECTION =====
  'home.ctaSection.left.brandLabel': 'Rx.K Seoul / rxk.thekseou.com',
  'home.ctaSection.left.heading': 'Experience Prescribed Beauty',
  'home.ctaSection.left.subtitle': '3-Step Daily Derma Reset Routine',
  'home.ctaSection.right.heading': 'Start Now',
  'home.ctaSection.right.body': 'Let Seoul dermatology and K-Beauty meet to prescribe your skin anew.',
  'home.ctaSection.right.ctaProducts': 'Our Products →',
  'home.ctaSection.right.ctaWhereToBuy': 'Where to Buy →',
  'home.ctaSection.stats.freeShipping': 'Free Shipping',
  'home.ctaSection.stats.freeShippingValue': 'Over ₩50,000',
  'home.ctaSection.stats.returns': 'Returns',
  'home.ctaSection.stats.returnsValue': 'Within 30 days',
  'home.ctaSection.stats.support': 'Support',
  'home.ctaSection.stats.supportValue': '24/7 Kakao',

  // ===== HOME HERO =====
  'home.hero.product01': 'Skin Priming Booster Essence',
  'home.hero.product02': 'Daily Rescue Serum',
  'home.hero.product03': 'Barrier Seal Cream',
  'home.hero.statDermaLabel': 'K+ Derma',
  'home.hero.statPrescribedLabel': 'Rx Prescribed',

  // ===== COMMON ADDITIONS =====
  'common.remove': 'Remove',
  'common.decrease': 'Decrease',
  'common.increase': 'Increase',
  'common.item': 'item',
  'common.items': 'items',
  'common.sending': 'Sending...',
  'common.all': 'All',

  // ===== ABOUT =====
  'about.hero.subtitle': 'Bridging Korean pharmaceutical expertise with Bangladeshi skincare needs since 2026.',
  'about.story.heading': 'Our Story',
  'about.story.p1': 'The.K Seoul Co., Ltd. is a Seoul-based dermocosmetic company founded with a singular mission: to bring prescription-grade Korean skincare to markets that have been underserved by authentic, clinically tested products.',
  'about.story.p2': 'Rx.K Seoul represents our flagship brand — the first dermocosmetic line developed specifically for Bangladesh, combining Korean pharmaceutical R&D with formulations adapted for tropical climates and common South Asian skin concerns.',
  'about.values.pillar1.title': 'Pharmacist-Led',
  'about.values.pillar1.desc': 'Every formulation is developed and reviewed by licensed pharmacists, not marketers.',
  'about.values.pillar2.title': 'Clinical Concentrations',
  'about.values.pillar2.desc': 'Active ingredients at percentages proven effective in peer-reviewed dermatology research.',
  'about.values.pillar3.title': 'Full Traceability',
  'about.values.pillar3.desc': 'Every product carries a unique verification code. Scan to confirm authenticity instantly.',
  'about.company.heading': 'Company Information',
  'about.company.siteDesc': 'Rx.K Seoul (rxk.thekseoul.com) is an e-commerce website operated for the online sale of The.K Seoul dermocosmetic skincare products in Bangladesh.',
  'about.company.concern': 'The.K Seoul is a business concern of Sol Grace Construction BD. Ltd.',
  'about.company.entity': 'Sol Grace Construction BD. Ltd.',
  'about.company.bin': 'BIN: 009212412-0108',
  'about.company.tin': 'TIN: 520132321674',
  'about.company.address': 'Address: 2/2-A, South Begunbari, Tejgaon I/A, Dhaka-1208, Bangladesh',
  'about.company.tradeLicense': 'Trade License: TRAD/DNCC/027028/2025',

  // ===== CONTACT =====
  'contact.hero.subtitle': "Reach Rx.K Seoul's Dhaka office and Korean headquarters.",
  'contact.channels.email.label': 'Email',
  'contact.channels.email.value': 'hello@thekseoul.com',
  'contact.channels.email.note': 'Placeholder — official email coming soon',
  'contact.channels.whatsapp.label': 'WhatsApp / Phone (BD)',
  'contact.channels.whatsapp.value': '+880 1331-661166',
  'contact.channels.whatsapp.note': 'Mon–Sat, 10:00–19:00 BST',
  'contact.channels.hq.label': 'Korea Headquarters',
  'contact.channels.hq.value': 'The.K Seoul Co., Ltd.',
  'contact.channels.hq.note': 'Anyang-si, Gyeonggi-do, South Korea',
  'contact.sendMessage.heading': 'Send a Message',
  'contact.form.namePlaceholder': 'Your full name',
  'contact.form.emailPlaceholder': 'your@email.com',
  'contact.form.phoneHelper': '+880 prefix optional',
  'contact.form.subjectPlaceholder': 'Select a topic',
  'contact.form.subjectProductInquiry': 'Product Inquiry',
  'contact.form.subjectPharmacyPartnership': 'Pharmacy Partnership',
  'contact.form.subjectInfluencer': 'Influencer Collaboration',
  'contact.form.subjectMediK': 'Medi.K Seoul Medical Tourism Inquiry',
  'contact.form.subjectPickK': 'Pick.K Seoul Influencer Program',
  'contact.form.subjectCounterfeit': 'Counterfeit Report',
  'contact.form.subjectOther': 'Other',
  'contact.form.messagePlaceholder': 'How can we help you?',
  'contact.form.maxChars': 'Maximum 500 characters',
  'contact.form.messageMinError': 'Message must be at least 20 characters.',
  'contact.form.consent': 'I agree to be contacted by Rx.K Seoul about my inquiry.',
  'contact.form.sending': 'Sending...',
  'contact.form.sendAnother': 'Send Another',
  'contact.success.heading': 'Message Sent',
  'contact.success.body': 'Thank you for reaching out. We will get back to you within 24 hours.',
  'contact.success.toast': 'Thank you. We will respond within 2 business days.',
  'contact.offices.bd.title': 'Bangladesh Operations',
  'contact.offices.bd.company': 'Sol Grace Construction BD. Ltd.',
  'contact.offices.bd.address': 'Apt-A1, House 94, Park Road, Block-K, Baridhara, Dhaka-1212, Bangladesh',
  'contact.offices.korea.title': 'Korea Headquarters',
  'contact.offices.korea.company': 'The.K Seoul Co., Ltd.',
  'contact.offices.korea.address': 'Anyang-si, Gyeonggi-do, South Korea (precise address TBD)',

  'faq.bottom.title': 'Still have questions?',
  'faq.bottom.body': 'Our support team is ready to help. Reach out any time.',
  'faq.bottom.cta': 'Contact Support →',

  // ===== SHIPPING & RETURNS =====
  'shipping.hero.subtitle': 'Fast, reliable delivery across Bangladesh with hassle-free returns.',
  'shipping.options.heading': 'Shipping Options',
  'shipping.returns.heading': 'Return, Refund & Cancellation Policy',
  'shipping.returns.desc': 'We want you to be completely satisfied with your purchase. If you are not, our return process is simple and straightforward.',
  'shipping.step1.title': 'Request Return',
  'shipping.step1.desc': 'Email us at support@rxkseoul.com within 7 days of delivery with your order number.',
  'shipping.step2.title': 'Ship It Back',
  'shipping.step2.desc': 'Pack the unused, sealed product in its original packaging. We will provide a return label.',
  'shipping.step3.title': 'Get Refunded',
  'shipping.step3.desc': 'Once we receive and inspect the item, your refund is processed within 7–10 working days.',
  'shipping.conditions.heading': 'Return Conditions',
  'shipping.condition1': 'Product must be unused, unopened, and in original packaging with all seals intact.',
  'shipping.condition2': 'Return request must be submitted within 7 days of delivery.',
  'shipping.condition3': 'Original order number and verification code must be provided.',
  'shipping.condition4': 'Opened, used, or damaged products (unless defective) are not eligible for return.',
  'shipping.condition5': 'Products purchased from unauthorized retailers are not eligible for returns or warranty.',
  'shipping.refundTimeline.heading': 'Refund Timeline',
  'shipping.refundTimeline.desc': 'Once your returned item is received and inspected, approved refunds are issued within 7–10 working days to your original payment method (or via bKash/bank transfer for Cash on Delivery orders). You will receive an email confirmation once your refund has been processed.',
  'shipping.cancellation.heading': 'Order Cancellation',
  'shipping.cancellation.desc': 'You may cancel your order free of charge at any time before it has been dispatched, by contacting support@rxkseoul.com or WhatsApp with your order number. Once an order has been dispatched for delivery, it can no longer be cancelled — our standard Return Policy above applies instead after delivery.',

  // ===== PRIVACY POLICY =====
  'privacy.section1.title': '1. Introduction',
  'privacy.section1.body': 'The.K Seoul Co., Ltd. ("we," "us," or "our") respects your privacy and is committed to protecting your personal data. This Privacy Policy explains how we collect, use, store, and protect your information when you use the Rx.K Seoul website, products, and services.',
  'privacy.section2.title': '2. Information We Collect',
  'privacy.section2.body': `We may collect the following types of information:

• Personal Information: Name, email address, phone number, shipping address, and billing information provided during purchase or account registration.
• Order Information: Product selections, purchase history, verification codes scanned, and transaction details.
• Technical Information: IP address, browser type, device information, and cookies for website functionality and analytics.
• Communication Data: Messages, inquiries, and feedback submitted through our contact forms or support channels.`,
  'privacy.section3.title': '3. How We Use Your Information',
  'privacy.section3.body': `Your information is used for the following purposes:

• Processing and fulfilling your orders, including shipping and delivery.
• Product authenticity verification and anti-counterfeit tracking.
• Customer support, responding to inquiries, and resolving issues.
• Sending order confirmations, shipping updates, and important product information.
• Improving our website, products, and services based on usage analytics.`,
  'privacy.section4.title': '4. Data Storage and Security',
  'privacy.section4.body': 'We store your data on secure servers provided by Supabase, which uses industry-standard encryption and security protocols. Your personal information is never sold, rented, or shared with third parties for marketing purposes. We retain your data only as long as necessary for the purposes outlined in this policy or as required by applicable law.',
  'privacy.section5.title': '5. Your Rights',
  'privacy.section5.body': `You have the right to:

• Access, update, or correct your personal information.
• Request deletion of your personal data, subject to legal retention requirements.
• Opt out of marketing communications at any time.
• Lodge a complaint with a data protection authority if you believe your rights have been violated.`,
  'privacy.section6.title': '6. Contact Us',
  'privacy.section6.body': 'For questions or concerns about this Privacy Policy, please contact us at support@rxkseoul.com.',

  // ===== TERMS OF SERVICE =====
  'terms.section1.title': '1. Acceptance of Terms',
  'terms.section1.body': 'By accessing or using the Rx.K Seoul website, products, or services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services. We reserve the right to update or modify these terms at any time, and continued use constitutes acceptance of the revised terms.',
  'terms.section2.title': '2. Products and Purchases',
  'terms.section2.body': `All product descriptions, pricing, and availability are subject to change without notice. We make every effort to display accurate colors and details, but actual product appearance may vary slightly due to screen settings. Prices are listed in Bangladeshi Taka (৳) and include applicable taxes unless stated otherwise.

We reserve the right to refuse or cancel any order for reasons including but not limited to product availability, errors in product or pricing information, or suspected fraudulent activity.`,
  'terms.section3.title': '3. Authenticity Verification',
  'terms.section3.body': 'Every Rx.K Seoul product is sold with a unique verification code. This code is intended for single-use verification by the original purchaser. Attempts to reproduce, duplicate, or tamper with verification codes may result in legal action. Products purchased from unauthorized retailers may not be eligible for verification, warranty, or support services.',
  'terms.section4.title': '4. Shipping and Delivery',
  'terms.section4.body': `We ship to addresses within Bangladesh and select international destinations. Standard delivery takes 5 business days inside Dhaka and 10 business days outside Dhaka; these are estimates and not guaranteed. Risk of loss and title for items pass to you upon delivery to the carrier. We are not responsible for delays caused by customs, weather, or other circumstances beyond our control.

Free shipping is available on orders over ৳3,000 within Bangladesh. Standard shipping rates apply to all other orders as displayed at checkout.`,
  'terms.section5.title': '5. Returns, Refunds, and Cancellations',
  'terms.section5.body': `Unused and sealed products may be returned within 7 days of delivery for a full refund. Products must be in their original packaging with all seals and verification codes intact. Used, opened, or damaged products are not eligible for return unless defective. Once we receive and inspect the returned item, approved refunds are issued within 7–10 working days to your original payment method (or via bKash/bank transfer for Cash on Delivery orders).

Orders may be cancelled free of charge at any time before dispatch by contacting support@rxkseoul.com with your order number. Orders that have already been dispatched cannot be cancelled and are instead subject to the return process described above.`,
  'terms.section6.title': '6. Intellectual Property',
  'terms.section6.body': 'All content on this website, including but not limited to text, graphics, logos, images, product descriptions, and software, is the property of The.K Seoul Co., Ltd. or its licensors and is protected by copyright, trademark, and other intellectual property laws. Unauthorized use, reproduction, or distribution is strictly prohibited.',
  'terms.section7.title': '7. Limitation of Liability',
  'terms.section7.body': 'To the maximum extent permitted by law, The.K Seoul Co., Ltd. shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of our products or services. Our total liability shall not exceed the amount you paid for the specific product or service giving rise to the claim.',
  'terms.section8.title': '8. Third-Party Advertising and Data Sharing',
  'terms.section8.body': 'We do not permit third-party advertisements on this website. We do not sell or share your personal information with third parties for their own marketing purposes. Any integration with a third-party service (such as a payment gateway or delivery courier) is limited to what is necessary to fulfill your order, and that third party is separately responsible for how it handles data you provide directly to it.',
  'terms.section9.title': '9. Governing Law',
  'terms.section9.body': 'These Terms of Service shall be governed by and construed in accordance with the laws of the Republic of Korea. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts of Seoul, South Korea.',
  'terms.section10.title': '10. Contact',
  'terms.section10.body': 'For questions about these Terms of Service, please contact us at support@rxkseoul.com.',
  // ===== AUTH =====
  'auth.login.title': 'Sign In',
  'auth.login.subtitle': 'Welcome back to Rx.K Seoul',
  'auth.login.email': 'Email',
  'auth.login.password': 'Password',
  'auth.login.remember': 'Keep me signed in',
  'auth.login.forgot': 'Forgot password?',
  'auth.login.submit': 'Sign In',
  'auth.login.orSocial': 'or continue with',
  'auth.login.comingSoon': 'coming soon',
  'auth.login.noAccount': "Don't have an account?",
  'auth.login.registerLink': 'Sign up',
  'auth.login.success': 'Welcome back!',
  'auth.login.error': 'Invalid email or password',

  'auth.register.title': 'Create Account',
  'auth.register.subtitle': 'Join Rx.K Seoul for exclusive benefits',
  'auth.register.email': 'Email',
  'auth.register.name': 'Full Name',
  'auth.register.phone': 'Phone Number',
  'auth.register.password': 'Password',
  'auth.register.confirmPassword': 'Confirm Password',
  'auth.register.terms': 'I agree to the Terms of Service (required)',
  'auth.register.privacy': 'I agree to the Privacy Policy (required)',
  'auth.register.marketing': 'I want to receive marketing emails and SMS (optional)',
  'auth.register.submit': 'Create Account',
  'auth.register.hasAccount': 'Already have an account?',
  'auth.register.loginLink': 'Sign in',
  'auth.register.success': 'Welcome to Rx.K Seoul!',
  'auth.register.error': 'Registration failed. Please try again.',

  'auth.forgot.title': 'Reset Password',
  'auth.forgot.subtitle': 'Enter your email and we will send you instructions',
  'auth.forgot.email': 'Email',
  'auth.forgot.submit': 'Send Reset Link',
  'auth.forgot.sent': 'If an account exists, a reset link has been sent.',
  'auth.forgot.backToLogin': 'Back to Sign In',

  // ===== MY PAGE =====
  'my.dashboard': 'Dashboard',
  'my.joinDate': 'Member since',
  'my.grade': 'Grade',
  'my.mileageBalance': 'Mileage',
  'my.logout': 'Sign Out',
  'my.recentOrders': 'Recent Orders',
  'my.orderDetail': 'Order Detail',
  'my.pending': 'Pending',
  'my.tracking': 'Tracking',
  'my.reorder': 'Reorder',

  'my.profile.title': 'Profile Settings',
  'my.profile.info': 'Personal Information',
  'my.profile.language': 'Language',
  'my.profile.saved': 'Profile updated',
  'my.profile.password': 'Change Password',
  'my.profile.currentPassword': 'Current Password',
  'my.profile.newPassword': 'New Password',
  'my.profile.confirmNewPassword': 'Confirm New Password',
  'my.profile.changePassword': 'Update Password',
  'my.profile.passwordChanged': 'Password updated (mock)',

  'my.orders.title': 'Orders',
  'my.orders.empty': 'No orders yet',

  'my.mileage.title': 'Mileage',
  'my.mileage.balance': 'Current Balance',
  'my.mileage.history': 'Transaction History',
  'my.mileage.empty': 'No transactions yet',
  'my.mileage.expires': 'Expires',
  'my.mileage.earn': 'Earned',
  'my.mileage.use': 'Used',
  'my.mileage.expire': 'Expired',
  'my.mileage.adjust': 'Adjusted',
  'my.mileage.policy1.title': '10% Purchase Reward',
  'my.mileage.policy1.desc': 'Earn 10% mileage on every purchase',
  'my.mileage.policy2.title': 'Review Reward',
  'my.mileage.policy2.desc': 'Get bonus mileage for product reviews',
  'my.mileage.policy3.title': 'Birthday Coupon',
  'my.mileage.policy3.desc': 'Special birthday mileage gift every year',

  'my.qna.title': 'Q&A',
  'my.qna.empty': 'No questions yet',
  'my.qna.answered': 'Answered',
  'my.qna.pending': 'Pending',
  'my.qna.formHint': 'Have a new question? Contact us directly for faster support.',

  'common.save': 'Save',

  'checkout.guestModal.title': 'How would you like to checkout?',
  'checkout.guestModal.subtitle': 'Sign in for a faster experience and mileage rewards',
  'checkout.guestModal.continue': 'Continue as Guest',
  'checkout.guestNoMileage': 'Mileage rewards are not available for guest checkout',
  'checkout.earnMileage': 'You will earn',

  // ===== CHECKOUT — order submission (Control Core) =====
  'checkout.placing': 'Placing your order...',
  'checkout.error.insufficientStock': 'Sorry, one or more items just went out of stock. Please adjust your cart and try again.',
  'checkout.error.codBlocked': 'Cash on Delivery isn’t available for this number. Please pay online to continue — we’ve selected an online option for you below.',
  'checkout.error.network': 'Could not reach our server. Please check your connection and try again.',
  'checkout.error.server': 'Something went wrong while placing your order. Please try again in a moment.',
  'checkout.error.validation': 'We could not process this order. Please review your details and try again.',
  'checkout.error.config': 'Ordering is temporarily unavailable. Please try again later.',


  // ===== HOME (new design) =====
  'homeV2.hero.tile1Label': 'GIFT SET',
  'homeV2.hero.tile1Title': 'Save {{amount}}',
  'homeV2.hero.tile2Label': '100% GENUINE',
  'homeV2.hero.tile2Title': 'Scan to verify',
  'homeV2.shop.byCategory': 'Shop by category',
  'homeV2.shop.bySkin': 'Shop by skin type',
  'homeV2.sbar.giftBox': 'Gift box',
  'homeV2.sbar.save': 'Save',
  'homeV2.sbar.add': 'Add to cart',
  'v2h.category': 'Category',
  'v2h.concern': 'Skin concern',
  'v2h.ritual': 'The 3-step ritual',
  'v2h.giftSet': 'GIFT SET',
  'v2h.saveOnSet': 'Save {{amount}} on the 3-Step Set',
  'v2h.shopNow': 'Shop now',
  'v2h.search': 'Search',
  'v2h.wishlist': 'Wishlist',
  'v2h.account': 'Account',
  'v2h.searchPlaceholder': 'Search products, ingredients or skin concerns',
  'v2h.closeSearch': 'Close search',
  'v2h.results': '{{count}} results',
  'v2h.popular': 'Popular products',
  'v2h.noResults': 'No products found. Try “serum” or “dark spots”.',
  'v2h.closeMenu': 'Close menu',
  'v2h.verify': 'Verify your product',
  'v2h.signIn': 'Sign in',
  'wishlist.title': 'Wishlist',
  'wishlist.lede': 'The products you saved, ready when you are.',
  'wishlist.kicker': 'Your wishlist',
  'wishlist.heading': 'Saved for',
  'wishlist.headingEm': 'later',
  'wishlist.addAll': 'Add all to cart',
  'wishlist.addedAll': 'All saved items added to your cart',
  'wishlist.saved': 'Saved to your wishlist',
  'wishlist.removed': 'Removed from your wishlist',
  'wishlist.emptyTitle': 'Nothing saved yet',
  'wishlist.emptyText': 'Tap the heart on any product to keep it here for later.',
  'wishlist.shop': 'Shop products',
  'wishlist.guestNote': 'Saved on this device.',
  'wishlist.signIn': 'Sign in to keep your wishlist on every device.',
  'wishlist.moreKicker': 'You may also like',
  'wishlist.more': 'Complete your',
  'wishlist.moreEm': 'ritual',
  'cartV2.title': 'Your bag',
  'cartV2.giftBox': 'Gift box · 3 steps',
  'cartV2.emptyTitle': 'Your bag is empty',
  'cartV2.emptyText': 'Start with the 3-step ritual, or pick the step your skin needs most.',
  'cartV2.shop': 'Shop products',
  'cartV2.awayPre': 'You are',
  'cartV2.awayPost': 'away from free delivery',
  'cartV2.free': 'Your order ships free',
  'cartV2.offerKicker': 'Complete the ritual',
  'cartV2.save': 'Save',
  'cartV2.add': 'Add',
  'cartV2.delivery': 'Delivery ৳70 in Dhaka, ৳120 outside · free over ৳3,000. Calculated at checkout.',
  'cartV2.cod': 'Cash on delivery',
  'homeV2.shop.byConcern': 'Shop by concern',
  'homeV2.shop.concern.dull': 'Dull skin',
  'homeV2.shop.concern.spots': 'Dark spots',
  'homeV2.shop.concern.dry': 'Dry skin',
  'homeV2.shop.concern.oily': 'Oily skin',
  'homeV2.shop.concern.sens': 'Sensitive',
  'homeV2.shop.concernLong.dull': 'Dull & tired',
  'homeV2.shop.concernLong.spots': 'Dark spots & marks',
  'homeV2.shop.concernLong.dry': 'Dry & tight',
  'homeV2.shop.concernLong.oily': 'Oily & pores',
  'homeV2.shop.concernLong.sens': 'Sensitive',
  'homeV2.shop.sortNew': 'Newest',
  'homeV2.shop.all': 'All',
  'homeV2.shop.allProducts': 'All products',
  'homeV2.shop.catSet': 'Sets',
  'homeV2.shop.catEssence': 'Toner & Essence',
  'homeV2.shop.catSerum': 'Serums',
  'homeV2.shop.catCream': 'Moisturisers',
  'homeV2.shop.categoryHeading': 'Category',
  'homeV2.shop.product': 'product',
  'homeV2.shop.products': 'products',
  'homeV2.shop.sortLabel': 'Sort:',
  'homeV2.shop.sortFeatured': 'Featured',
  'homeV2.shop.sortLow': 'Price: low to high',
  'homeV2.shop.sortHigh': 'Price: high to low',
  'homeV2.shop.sale': 'Sale',
  'homeV2.shop.empty': 'No products match yet.',
  'homeV2.shop.showAll': 'Show all products',
  'homeV2.shop.showMore': 'Show more',
  'homeV2.ritual.label': 'The daily ritual',
  'homeV2.ritual.heading': 'Open · Treat · Lock',
  'homeV2.ritual.headingEm': 'in under five minutes',
  'homeV2.ritual.cta': 'Shop the 3-Step Set',
  'homeV2.watch.label': 'Watch & shop',
  'homeV2.watch.heading': 'See the ritual',
  'homeV2.watch.headingEm': 'in action',
  'homeV2.watch.full': 'Full routine',
  'homeV2.watch.step': 'Step',
  'homeV2.watch.shopNow': 'Shop now',
  'homeV2.brand.kicker': 'From Seoul to Dhaka',
  'homeV2.brand.heading': 'Korean pharmacy skincare,',
  'homeV2.brand.headingEm': 'made for Bangladesh.',
  'homeV2.brand.body': 'brings pharmacist-chosen Korean formulas home: clinical-grade ingredients, developed in Seoul and made for our heat and humidity.',
  'homeV2.brand.fact1Title': 'Seoul',
  'homeV2.brand.fact1Body': 'Formulated and made in Korea',
  'homeV2.brand.fact2Title': 'Rx',
  'homeV2.brand.fact2Body': 'Pharmacist-recommended formulas',
  'homeV2.brand.fact3Title': 'BSTI',
  'homeV2.brand.fact3Body': 'Certified for Bangladesh',
  'homeV2.brand.fact4Title': '2026',
  'homeV2.brand.fact4Body': 'Launched at K-Goods Festa with KOTRA',
  'homeV2.brand.ctaStory': 'Read our story',
  'homeV2.brand.ctaWhere': 'Where to buy',
  'homeV2.launch.label': 'K-Goods Festa 2026',
  'homeV2.launch.heading': 'Where K-Beauty met',
  'homeV2.launch.headingEm': 'Bangladesh',
  'homeV2.launch.subtitle': 'Co-hosted by KOTRA and the Embassy of the Republic of Korea · Jamuna Future Park · 19–20 June 2026',
  'homeV2.launch.cap1': 'A full house at the Rx.K Testing Zone',
  'homeV2.launch.cap2': 'Live consultation at the VIP Corner',
  'homeV2.launch.cap3': 'Science-first skincare advice',
  'homeV2.launch.cap4': 'Discovering the 3-Step Daily Treatment',
  'homeV2.launch.cap5': 'The.K Seoul pavilion, Jamuna Future Park',
  'homeV2.verify.kicker': '100% genuine guarantee',
  'homeV2.verify.heading': 'Scan. Verify.',
  'homeV2.verify.headingEm': 'Trust.',
  'homeV2.verify.body': 'Every Rx.K Seoul box carries a silver hologram with its own QR code and serial number. Check yours in ten seconds, straight from The.K Seoul Co., Ltd. in Korea.',
  'homeV2.verify.step1': 'Find the silver hologram on top of the box',
  'homeV2.verify.step1Note': 'Tilt it: it shimmers. Copies can’t fake that.',
  'homeV2.verify.step2': 'Scan its QR code with your phone camera',
  'homeV2.verify.step2Note': 'No app needed',
  'homeV2.verify.step3': 'Green means genuine',
  'homeV2.verify.step3Note': 'You’ll see the batch, manufacture and expiry dates',
  'homeV2.verify.cta': 'Verify your product',
  'homeV2.verify.note': 'DGDA-registered verification system · Something looks wrong? Call 09617 66 11 66',
  'homeV2.verify.guide': 'Watch the full guide · 1:30',
  'homeV2.verify.holoTitle': 'The silver hologram',
  'homeV2.verify.holoNote': '27 × 28 mm · on top of every box',
  'homeV2.services.s1Title': 'Cash on delivery',
  'homeV2.services.s1Body': 'Pay the rider at your door',
  'homeV2.services.s2Title': 'Free delivery',
  'homeV2.services.s2Body': 'On orders over ৳3,000',
  'homeV2.services.s3Title': '100% genuine',
  'homeV2.services.s3Body': 'Every box is QR verified',
  'homeV2.services.s4Title': 'Pharmacist verified',
  'homeV2.services.s4Body': 'Made in Korea · BSTI certified',
} as const;